import React from "react";
import { WaitConfigEditor } from "../features/wait-config";
import { withRestaurantId } from "../shared/components/layout";

const WaitConfigEditorWithId = withRestaurantId(WaitConfigEditor);

const WaitConfigPage: React.FC = () => {
  return <WaitConfigEditorWithId />;
};

export default WaitConfigPage;
